import { useEffect, useState } from "react";
// import useForm from '../hooks/useForm';
// import { FormField, Button, LoadingIcon } from '@prosolve/common-components-ui'
// import useFetch from '../hooks/useFetch';
// import useMediaQuery from '../hooks/useMediaQuery';
import FeedbackWizard from './FeedbackWizard/FeedbackWizard';
// import TeamSelector from "./TeamSelector";
import { useNavigate } from "react-router-dom";

const randomRange = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min;
}

export default (routeProps = {}) => {
  const { path } = routeProps

  const navigate = useNavigate();
  
  // const isSmallView = useMediaQuery('(max-width: 620px)');

  // const fetch = useFetch();

  // const [isBusy, setIsBusy] = useState(false);
  // const [showInvalidLogin, setShowInvalidLogin] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);

  const userId = urlParams.get('userId');
  const classId = urlParams.get('classId');
  const eventId = urlParams.get('eventId');
  const assessmentName = urlParams.get('assessmentName');
  const mod = urlParams.get('mod');
  const teamColor = urlParams.get('teamColor');
  const teamName = urlParams.get('teamName');
  const episodeId = urlParams.get('episodeId');
  const practice = urlParams.get('practice');
  const assignmentId = urlParams.get('assignmentId');
  const assignmentTargetType = urlParams.get('assignmentTargetType');
  const groupId = urlParams.get('groupId');
  const sessionId = urlParams.get('sessionId');
  const followUps = urlParams.get('followUps');

  const isPractice = practice === 'true'

  let hasRequired = false;
  let initSurveyData = {};
  if (path === 'survey' && assessmentName) {
    initSurveyData = {
      userId: userId || '',
      eventId,
      classId,
      episodeId,
      assessmentName,
      mod,
      teamColor,
      teamName,
      assignmentId,
      assignmentTargetType,
      groupId,
      sessionId
    }
    hasRequired = true;
  } else if (userId && classId && assessmentName) {
    initSurveyData = {
      userId,
      classId,
      episodeId,
      assessmentName
    }
    hasRequired = true;
  }

  const surveyData = initSurveyData;

  // const [surveyData, setSurveyData] = useState(initSurveyData);

  // const [showTeamSelector, setShowTeamSelector] = useState(false)

  const [isSurveyComplete, setIsSurveyComplete] = useState(false);

  // Followup assessment determined by the API's followupBranchConfig analysis on submit.
  // When set, it always wins over the url-driven followUps chain.
  const [apiFollowUpUrl, setApiFollowUpUrl] = useState('');

  const [assessmentData, setAssessmentData] = useState({})

  const { backgroundImage, intro: { redirectOnCompleteUrl, backgroundImageOrientation = '', completionMessage = '' } = {} } = assessmentData;

  const redirectsToSoefiaScorecard = redirectOnCompleteUrl === 'https://prosolve.soefia.com/scorecard'

  if (redirectsToSoefiaScorecard && !surveyData.teamColor) {
    surveyData.teamColor = 'Red'
  }
  if (redirectsToSoefiaScorecard && !surveyData.teamName) {
    surveyData.teamName = randomRange(0, 1000000)
  }
  if (redirectsToSoefiaScorecard && !surveyData.groupId) {
    surveyData.groupId = encodeURIComponent((`${surveyData.teamColor}-${surveyData.teamName}-${(new Date()).getTime()}`).replace(/\s+/g, ''))
  }
  if (redirectsToSoefiaScorecard && !surveyData.eventId) {
    surveyData.eventId = (new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10))
  }

  const getFollowUpInfo = () => {
    const followUpInfo = { inFollowUp: false, followUpUrl: '' }

    const followUpsArray = followUps ? followUps.split(',') : []

    if (followUpsArray.length > 0) {

      const followUpAssessmentNameCheck = mod ? `${assessmentName}<mod>${mod}` : assessmentName

      const currAssessmentFollowUpIndex = followUpsArray.indexOf(followUpAssessmentNameCheck)

      if (currAssessmentFollowUpIndex > -1) {
        followUpInfo.inFollowUp = true
      }

      const followUpAssessmentName = followUpsArray[currAssessmentFollowUpIndex + 1]

      if (Boolean(followUpAssessmentName)) {
        const followUpUrl = new URL(window.location.href);

        const followUpAssessmentNameSplit = followUpAssessmentName.split('<mod>')

        const finalFollowUpAssessmentName = followUpAssessmentNameSplit[0]

        const followUpMod = followUpAssessmentNameSplit[1]

        followUpUrl.searchParams.set('assessmentName', finalFollowUpAssessmentName);

        if(followUpMod) {
          followUpUrl.searchParams.set('mod', followUpMod);
        } else {
          followUpUrl.searchParams.delete('mod');
        }

        followUpInfo.followUpUrl = followUpUrl.toString()
      }
    }

    return followUpInfo
  }

  const { inFollowUp, followUpUrl } = getFollowUpInfo()

  const buildApiFollowUpUrl = (followupAssessmentName, followupAssessmentMod) => {
    // Carry all current params along and just swap the assessmentName,
    // adding/swapping the followup's mod (or clearing the current one)
    const url = new URL(window.location.href);
    url.searchParams.set('assessmentName', followupAssessmentName);
    if (followupAssessmentMod) {
      url.searchParams.set('mod', followupAssessmentMod);
    } else {
      url.searchParams.delete('mod');
    }
    return url.toString();
  }

  useEffect(() => {
    if (isSurveyComplete) {
      if (Boolean(apiFollowUpUrl)) {
        window.open(apiFollowUpUrl, '_self')
      } else if (Boolean(followUpUrl)) {
        window.open(followUpUrl, '_self')
      } else if (Boolean(redirectOnCompleteUrl)) {
        window.open(redirectOnCompleteUrl, '_self')
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSurveyComplete, redirectOnCompleteUrl, apiFollowUpUrl])

  /*
  const formSchema = {
    requiredFields: ['code'],
    initData: {
      code: ''
    }
  }


  const formData = useForm(formSchema)

  const onClickSubmit = async () => {
    if (formData.isValid() && !isBusy) {
      setIsBusy(true)

      const { code: codeRaw = '' } = formData.values;

      const code = codeRaw.toUpperCase();

      const response = await fetch(
        `quest/code/redeemed?code=${code}`, 
        { 
          method: 'GET',
        }
      )

      const jsonData = await response.json() || {};

      const { 
        success,
        code: questCode = '',
        classId = '',
        seasonIndex = ''
      } = jsonData;

      if (success && questCode && seasonIndex) {
        setShowInvalidLogin(false)

        const isStarforce = seasonIndex === 201;

        const openSurveyObj = {
          classId,
          assessmentName: isStarforce ? 'StudentStarforcePostProgramSurvey' : 'StudentApexPostProgramSurvey'
        }

        if (!isStarforce) {
          setShowTeamSelector(true)
        }

        setSurveyData(openSurveyObj);
      } else {
        setShowInvalidLogin(true)
      }

      setIsBusy(false)
    }
  }

  const onTeamColorSelected = (teamColor) => {
    console.log(teamColor);

    const updatedSurveyData = {
      ...surveyData,
      teamColor,
    }

    setSurveyData(updatedSurveyData);
    setShowTeamSelector(false)
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSubmit();
    }
  }*/

  const onSurveySuccess = (metadata, followupAssessmentName, followupAssessmentMod) => {
    if (followupAssessmentName) {
      setApiFollowUpUrl(buildApiFollowUpUrl(followupAssessmentName, followupAssessmentMod))
    }
    setIsSurveyComplete(true)
    if (metadata && metadata.isSoefiaAssessment) {
      const assessmentAnswerId = metadata._id;
      if (assessmentAnswerId) {
        let additionalParams = ''
        if (redirectsToSoefiaScorecard) {
          additionalParams = `&redirectOnCompleteUrl=${redirectOnCompleteUrl}&groupId=${surveyData.groupId}`
        }
        navigate(`/surveyResults?assessmentAnswerId=${assessmentAnswerId}${additionalParams}`);
      }
    } else {
      // Post message to parent to notify survey has been completed if not of the Soefia type
      window.parent.postMessage(
        { type: "SURVEY_COMPLETE" },
        "*"
      );
      // Surveys launched into their own tab (e.g. the student portal's pulse checks)
      // have an opener instead of a parent
      window.opener?.postMessage(
        { type: "SURVEY_COMPLETE" },
        "*"
      );
    }
  }

  const orientation = backgroundImageOrientation === 'topLeft' ? 'top left' : 'center center';

  return (
    isSurveyComplete && !Boolean(followUpUrl) && !Boolean(apiFollowUpUrl) ?
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      background: backgroundImage ?
      `url("${backgroundImage}") ${orientation}/cover no-repeat fixed` : 
      `url("https://api.portal.questboxes.com/api/file/Product%20Images/apex-pre-survey-background.png") top left/cover no-repeat fixed`
    }}>
      <div style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: '#00000080',
        fontSize: '16px',
        color: '#ffffff',
        overflow: 'auto',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          color: '#ffffff',
          fontWeight: 'bold',
          fontSize: '48px',
          textAlign: 'center'
        }}>
          {completionMessage || 'Thank You For Completing Our Survey!'}
        </div>
      </div>
    </div>
    // :
    // showTeamSelector && Boolean(surveyData) ?
    // <TeamSelector onTeamColorSelected={onTeamColorSelected} />
    :
    hasRequired ?
    // !showTeamSelector && Boolean(surveyData) ?
    <FeedbackWizard 
      isPractice={isPractice}
      assessmentName={surveyData.assessmentName} 
      mod={surveyData.mod} 
      classId={surveyData.classId}
      episodeId={surveyData.episodeId} 
      eventId={surveyData.eventId} 
      userId={surveyData.userId} 
      teamColor={surveyData.teamColor} 
      teamName={surveyData.teamName} 
      assignmentId={surveyData.assignmentId}
      assignmentTargetType={surveyData.assignmentTargetType}
      groupId={surveyData.groupId}
      sessionId={surveyData.sessionId}
      onSuccess={onSurveySuccess} 
      onAssessmentDataChanged={(assessmentDataObj) => setAssessmentData(assessmentDataObj || {})}
      inFollowUp={inFollowUp}
      hasFollowUp={Boolean(followUpUrl)}
    />
    :
    <div style={{
      position: 'relative', 
      height: 'calc(100vh)', 
      width: '100%',
      display: 'flex',
      background: '#1282B2',
      flexDirection: 'column',
    }}>
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        background: 'inherit',
        color: '#ffffff',
        fontWeight: 'bold',
        fontSize: '32px',
        textAlign: 'center',
        overflow: 'auto',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div>{'Missing required url parameters'}</div>
      </div>
    </div>
    // :
    // <div style={{
    //   display: 'flex',
    //   flexDirection: isSmallView ? 'column' : 'row',
    //   rowGap: '15px',
    //   height: '100%',
    //   boxSizing: 'border-box',
    //   overflow: 'auto',
    //   overflowX: 'hidden',
    //   background: `url("https://api.portal.questboxes.com/api/file/Product%20Images/apex-pre-survey-background.png") top left/cover no-repeat fixed`
    // }}>

    //   <div style={{
    //     flex: 1,
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: isSmallView ? 'flex-start' : 'center',
    //     alignItems: 'center',
    //     padding: '20px',
    //     zIndex: '100',
    //     marginTop: isSmallView ? '-15px' : '0px'
    //   }}>

    //    <div style={{ display: 'flex', flexDirection: 'column' }}>

    //       <div style={{ flex: 1, display: 'flex', marginBottom: '20px', textAlign: isSmallView ? 'center' : 'center' }}>
    //         <div style={{ color: '#ffffff'}}>
    //           <div style={{ fontWeight: 'bold', fontSize: '40px', color: '#ffc200' }}>{"ENTER CLASS CODE"}</div>
    //         </div>
    //       </div>

    //       <FormField
    //         fieldStyle={{ 
    //           fontSize: '18px', 
    //           textAlign: isSmallView ? 'center' : 'left',
    //           textTransform: 'uppercase'
    //         }}
    //         // label='Code'
    //         labelStyle={{ color: '#ffffff', fontWeight: 'bold'}}
    //         fieldId='code'
    //         type='text'
    //         formData={formData}
    //         onKeyDown={onKeyDown}
    //       />

    //       <div style={{ height: '25px', position: 'relative'}}>

    //       {
    //         (!isBusy && showInvalidLogin) ?
    //         <div style={{
    //           color: '#ef0c0c',
    //           fontStyle: 'italic',
    //           fontSize: '14px',
    //           position: 'absolute',
    //           top: '3px',
    //           left: '3px'
    //         }}>
    //           {'Code not found or has not been redeemed by your teacher.'}
    //         </div>
    //         :
    //         <div>&nbsp;</div>
    //       }

    //       </div>

    //       <div style={{ display: 'flex', alignItems: 'center', justifyContent: isSmallView ? 'center' : 'center' }}>
    //         <Button 
    //           style={{ 
    //             display: 'inline-flex', 
    //             marginRight: '10px', 
    //             fontWeight: 'bold', 
    //             fontSize: '24px',
    //             width: '150px', 
    //             height: '40px',
    //             background: 'transparent'
    //           }} 
    //           onClick={onClickSubmit} 
    //           $colored={true}
    //         >
    //             {'SUBMIT'}
    //         </Button>
    //         {
    //           isBusy &&
    //           <LoadingIcon />
    //         }
    //       </div>

    //     </div>
    //   </div>
    // </div>
  )
}